import { MenuItem } from '@app/interfaces';

export class MenuItems {
  // @ts-ignore
  items: MenuItem[] = [
    {
      title: 'home',
      url: '/home',
      mdiIcon: true,
      icon: 'speedometer',
      permissionsKey: 'dashboard',
    },
    {
      title: 'assets',
      url: '/assets',
      mdiIcon: true,
      icon: 'speedometer',
      children: [
        {
          title: 'vehicles',
          url: '/assets/vehicles',
          exact: true,
          icon: '',
          permissionsKey: 'vehicles',
        },
        {
          title: 'drivers',
          url: '/assets/drivers',
          exact: true,
          icon: '',
          permissionsKey: 'drivers',
        },
        {
          title: 'trailers',
          url: '/assets/trailers',
          exact: true,
          icon: '',
          permissionsKey: 'trailers',
        },
        {
          title: 'vendors',
          url: '/assets/vendors',
          exact: true,
          icon: '',
          permissionsKey: 'vendors',
        },
        {
          title: 'warehouses',
          url: '/assets/warehouses',
          exact: true,
          icon: '',
          permissionsKey: 'warehouses',
        },
      ],
    },
      {
      title: 'locations',
      url: '/locations',
      mdiIcon: true,
      icon: 'locations',
      children: [
        {
          title: 'places',
          url: '/locations/places',
          exact: true,
          icon: '',
          permissionsKey: 'places',
        },
        // {
        //   title: 'zones',
        //   url: '/locations/zones',
        //   exact: true,
        //   icon: '',
        //   permissionsKey: 'zones',
        // },
      ],
    },
    {
      title: 'clients',
      url: '/clients',
      icon: 'people',
      permissionsKey: 'clients',
      children: [
        {
          title: 'clients-list',
          url: '/clients',
          exact: true,
          icon: '',
          permissionsKey: 'clients',
        },
      ],
    },
    {
      title: 'device-settings',
      url: '/device-settings',
      icon: 'people',
      children: [
        {
          title: 'devices',
          url: '/device-settings/devices',
          exact: true,
          icon: '',
          permissionsKey: 'devices',
        },
        {
          title: 'commands',
          url: '/device-settings/commands',
          exact: true,
          icon: '',
          permissionsKey: 'commands',
        },
      ],
    },
    {
      title: 'accounts',
      url: '/accounts',
      mdiIcon: true,
      icon: 'accounts',
      children: [
        {
          title: 'users',
          url: '/accounts/users',
          exact: true,
          icon: '',
          permissionsKey: 'users',
        },
        {
          title: 'appRolesAndPermissions',
          url: '/accounts/roles',
          exact: true,
          icon: '',
          permissionsKey: 'roles',
        },
      ],
    },
    {
      title: 'app-settings',
      url: '/settings/cms',
      mdiIcon: true,
      icon: 'settings',
      // permissionsKey: 'setting',
      children: [
        {
          title: 'cms',
          url: '/settings/content-management-system',
          exact: true,
          icon: '',
          permissionsKey: 'cms',
        },
      ],
    },
  ];
}
